import { GlobalMemberStatus } from './member-status.model';

export class SelectCurrentMemberAndDate {
  static readonly type = '[MemberStatus] SelectCurrentMemberAndDate';
  constructor(public memberId: string, public currentDate: Date) {}
}

export class LoadCurrentMemberStatus {
  static readonly type = '[MemberStatus] LoadCurrentMemberStatus';
}

export class LoadCurrentMemberStatusSuccess {
  static readonly type = '[MemberStatus] LoadCurrentMemberStatusSuccess';
  constructor(public data: GlobalMemberStatus) {}
}

export class LoadCurrentMemberStatusFailure {
  static readonly type = '[MemberStatus] LoadCurrentMemberStatusFailure';
  constructor(public error: any) {}
}

export class SelectCurrentMemberAndEffectiveDate {
  static readonly type = '[MemberStatus] SelectCurrentMemberAndEffectiveDate';
  constructor(public memberId: string, public effectiveDate: Date) {}
}

export class LoadMemberStatusAtEffectiveDate {
  static readonly type = '[MemberStatus] LoadMemberStatusAtEffectiveDate';
}

export class LoadMemberStatusAtEffectiveDateSuccess {
  static readonly type = '[MemberStatus] LoadMemberStatusAtEffectiveDateSuccess';
  constructor(public data: GlobalMemberStatus) {}
}

export class LoadMemberStatusAtEffectiveDateFailure {
  static readonly type = '[MemberStatus] LoadMemberStatusAtEffectiveDateFailure';
  constructor(public error: any) {}
}
